<script lang="ts" setup>
  import dayjs from 'dayjs'
  const props = withDefaults(
    defineProps<{
      format?: string
      rawDate: string
      showFrom?: boolean
    }>(),
    {
      format: 'D MMMM, YYYY',
    },
  )
  const { locale } = useI18n()

  const parsedDate = computed(() => dayjs(props.rawDate).locale(locale.value).format(props.format))
</script>

<template>
  <div class="parsed-date">
    <template v-if="showFrom">
      {{ $t('order_from') }}
    </template>
    {{ parsedDate }}
  </div>
</template>

<style lang="scss" scoped>
  .parsed-date {
    @include font-montserrat-400(12px, 15px, var(--dark-grey));
  }
</style>
